import Vue from 'vue'
import { makeQueryStringDync, errorServeiceHandler } from '../helper'
const state = {
    graphsData: undefined,
    lowerGraphsData: undefined
};

const getters = {
    getgraphsData: (state) => {
        return state.graphsData;
    },
    getlowerGraphsData: (state) => {
        console.log("getters " , state);
        return state.lowerGraphsData;
    }
};

const mutations = {
    setgraphsData: (state, data) => {
        console.log("mutation ",data);
        state.graphsData = data;
    },
    setlowerGraphsData: (state, data) => {
        state.lowerGraphsData = data;
    }
};

const actions = {
    getMqStat: (context,payload) => {
        return new Promise( (resolve, reject) => {
            // let graphData = JSON.parse(localStorage.getItem('mqstats'))
            // if (graphData) {
            //     if (Object.keys(graphData).length) {
            //     resolve(graphData)
            //     return
            //     }
            // }
            let queryStr = makeQueryStringDync(payload)
            fetch(context.getters.baseUrl + '/lco/v1/stat/mqstats' + queryStr, {
            method: 'GET'
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()
            }).then((data) => {
                // localStorage.setItem("mqstats",JSON.stringify(data))
                resolve(data)
                //type CLK DLK
            }).catch((error) => {
                reject(error);
            });
        });
    },
    getCredit: (context, payload) => {
        return new Promise( (resolve, reject) => {
            // let graphData = JSON.parse(localStorage.getItem('credits'))
            // if (graphData) {
            //     if (Object.keys(graphData).length) {
            //     resolve(graphData)
            //     return
            //     }
            // }
            let queryStr = makeQueryStringDync(payload)
            fetch(context.getters.baseUrl + '/lco/v1/stat/credits' + queryStr, {
            method: 'GET'
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()
            }).then((data) => {
                // localStorage.setItem("credits",JSON.stringify(data))
                resolve(data)
                //type CLK DLK
            }).catch((error) => {
             
                reject(error);
            });
        });
    },
    getRenew: (context, payload) => {
        return new Promise( (resolve, reject) => {
            // let graphData = JSON.parse(localStorage.getItem('mqexpiry'))
            // if (graphData) {
            //     if (Object.keys(graphData).length) {
            //     resolve(graphData)
            //     return
            //     }
            // }
            let queryStr = makeQueryStringDync(payload)
            fetch(context.getters.baseUrl + '/lco/v1/stat/expiry' + queryStr, {
            method: 'GET'
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()
            }).then((data) => {
                // localStorage.setItem("mqexpiry",JSON.stringify(data))
                resolve(data)
                //type CLK DLK
            }).catch((error) => {
                
                reject(error);
            });
        });
    },
    getRevenues: (context, payload) => {
        return new Promise( (resolve, reject) => {
            // let graphData = JSON.parse(localStorage.getItem('revenues'))
            // if (graphData) {
            //     if (Object.keys(graphData).length) {
            //     resolve(graphData)
            //     return
            //     }
            // }
            let queryStr = makeQueryStringDync(payload)
            fetch(context.getters.baseUrl + '/lco/v1/stat/revenues' + queryStr, {
            method: 'GET'
           })
           .then(errorServeiceHandler)
           .then((response) => {
                 return response.json()
            }).then((data) => {
                // localStorage.setItem("revenues",JSON.stringify(data))
                resolve(data)
                //type CLK DLK
            }).catch((error) => {
                reject(error);
            });
        });
    },
};

export default {
    state, getters, mutations, actions
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboardModule.js